import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

// When this page is loaded inside an MSAL auth popup (the opener launched it and the URL
// carries the auth response), do NOT bootstrap the Angular app. The opener window's MSAL
// instance reads the response off this popup and closes it. Bootstrapping here would
// re-render the login page inside the popup and trip MSAL's "running in a popup" block.
// This lets the popup keep using the app's own /login route as the redirect URI.
const isAuthPopup =
  !!window.opener &&
  window.opener !== window &&
  /(^|[#&?])(code|error|state|id_token|access_token)=/.test(window.location.hash + window.location.search);

if (!isAuthPopup) {
  platformBrowserDynamic().bootstrapModule(AppModule)
    .catch(err => console.error(err));
}
